import React from 'react';
import { Typography } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import './connectionStatusOverlay.style.scss';

interface ConnectionStatusOverlayProps {
  onRetry: () => void;
}

const ConnectionStatusOverlay: React.FC<ConnectionStatusOverlayProps> = ({ onRetry }) => {
  return (
    <div className="connection-overlay">
      <div className="connection-content">
        <WifiOffIcon sx={{ fontSize: 48, color: '#fff', mb: 2 }} />
        <Typography variant="h6" sx={{ mb: 3, color: '#fff' }}>
          There's a connection problem with the server. Please try again later.
        </Typography>
        <button 
          className="connection-retry-button"
          onClick={onRetry}
        >
          Retry
        </button>
      </div>
    </div>
  );
};

export default ConnectionStatusOverlay; 